import {useQuery, useInfiniteQuery, useQueryClient, useMutation} from "react-query";
import {toast} from 'react-toastify';
import API from './utils/api';
import {
    TaxReliefDto, TaxReliefPaginator,
    CreateCompanyTaxReliefDto, QueryTaxReliefDto,
    UpdateTaxReliefDto
} from "../models/tax-relief.dto";
import ENDPOINTS from "./utils/endpoints";

export function useGetCompanyTaxRelief(companyId: number, options?: QueryTaxReliefDto, queryOptions?: any) {
    const url = ENDPOINTS.PROCESSING_COMPANY.COMPANY_TAX_RELIEF.GET;
    const request = API.ProcessingCompanyAPI.getCompanyTaxRelief(companyId, options);

    const { data, isLoading, error, refetch } = useQuery<TaxReliefPaginator, Error>(
        [url, companyId, options],
        (() => request),
        {...API.Handlers.pageParamOption, ...queryOptions}
    );

    return { data, isLoading, error, refetch };
}

export function useGetCompanyTaxReliefById(companyId: number, id: number) {
    const url = ENDPOINTS.PROCESSING_COMPANY.COMPANY_TAX_RELIEF.DETAIL;
    const request = API.ProcessingCompanyAPI.getCompanyTaxReliefById(companyId, id);

    const {data, isLoading, error} = useQuery<{ data:TaxReliefDto }, Error>(
        [url, companyId, id],
        (() => request),
        {
            enabled: !!(id),
        }
    );

    return {
        data: data,
        isLoading,
        error,
    };
}

export function useCreateCompanyTaxRelief() {
    const queryClient = useQueryClient();

    return useMutation(
        ({companyId, payload}: {companyId: number, payload: CreateCompanyTaxReliefDto}) => API.ProcessingCompanyAPI.createCompanyTaxRelief(companyId, payload),
        {
            onSuccess: () => {
                toast.success('Record created successfully');
                queryClient.invalidateQueries(ENDPOINTS.PROCESSING_COMPANY.COMPANY_TAX_RELIEF.GET);
            },
            onError: API.Handlers.onErrorHandler,
        }
    )
}

export function useUpdateCompanyTaxRelief() {
    const queryClient = useQueryClient();

    return useMutation(
        ({payload, companyId, id}: {payload: UpdateTaxReliefDto, companyId: number, id: number}) => API.ProcessingCompanyAPI.updateCompanyTaxRelief(companyId, id, payload),
        {
            onSuccess: () => {
                toast.success('Record updated successfully');
                queryClient.invalidateQueries(ENDPOINTS.PROCESSING_COMPANY.COMPANY_TAX_RELIEF.GET);
            },
            onError: API.Handlers.onErrorHandler,
        }
    )
}

export function useDeleteCompanyTaxRelief() {
    const queryClient = useQueryClient();

    return useMutation(
        ({ companyId, id}: {companyId: number, id: number}) => API.ProcessingCompanyAPI.deleteCompanyTaxRelief(companyId, id),
        {
            onSuccess: () => {
                toast.success('Record deleted successfully');
                queryClient.invalidateQueries(ENDPOINTS.PROCESSING_COMPANY.COMPANY_TAX_RELIEF.GET);
            },
            onError: API.Handlers.onErrorHandler,
        }
    )
}
